/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useContext } from 'react';
// import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { getImageFile } from 'utils/stringUtils';
import StyledLink from 'components/StyledLink';
import _isEmpty from 'lodash/isEmpty';
import NavBarContext from '../../navBarContext';
import BlogMainItem from './BlogMainItem';
import MostPopular from './MostPopular';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
  rightContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: '17px 34px',
  },
  header: {
    marginBottom: 10,
  },
  lists: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 28,
  },
  image: {
    width: '100%',
    height: 139,
    marginBottom: 6,
    objectFit: 'cover',
  },
  listItem: {
    width: 246,
    marginRight: 21,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  imageRoot: {
    width: 246,
  },
  name: {
    width: 246,
  },
}));

function News() {
  const classes = useStyles();
  const { news, popularNews, sendMixpanelEvent } = useContext(NavBarContext);

  const clickHandler = (name, element) => {
    sendMixpanelEvent('Menu Item - Clicked', {
      type: 'News',
      name,
      element,
    });
  };
  if (_isEmpty(news)) return null;
  return (
    <div className={classes.root} data-test-id="menu-news">
      <div className={classes.rightContent} data-test-id="menu-news-latest">
        <Typography variant="h6" className={classes.header} color="textPrimary">
          Latest News
        </Typography>
        <BlogMainItem
          data={news[0].fields}
          isLatest
          clickHandler={clickHandler}
          resourceType="news"
        />
        <div className={classes.lists}>
          {news.slice(1, 4).map(({ fields }) => {
            const imageSrc = getImageFile(fields);
            const { slug, name } = fields;
            return (
              <StyledLink link={`/articles/${slug}`} key={slug}>
                <div className={classes.listItem}>
                  <div
                    className={classes.imageRoot}
                    onClick={() => clickHandler(name, 'image')}
                  >
                    <img src={imageSrc} alt={name} className={classes.image} />
                  </div>
                  <div
                    className={classes.name}
                    onClick={() => clickHandler(name, 'text')}
                  >
                    <Typography variant="overline" color="textPrimary">
                      {name}
                    </Typography>
                  </div>
                </div>
              </StyledLink>
            );
          })}
        </div>
      </div>
      <MostPopular data={popularNews} isNews clickHandler={clickHandler} />
    </div>
  );
}

export default News;
